import { createTheme } from '@one-thd/sui-atomic-components';

const MothersDaySecondaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

MothersDaySecondaryOne.palette['--sui-palette-background-primary'] = '248 124 86';
MothersDaySecondaryOne.palette['--sui-palette-button-background-primary'] = '255 255 255';
MothersDaySecondaryOne.palette['--sui-palette-text-primary'] = '255 255 255';
MothersDaySecondaryOne.palette['--sui-palette-text-subtle'] = '255 255 255';

export { MothersDaySecondaryOne };
